module.exports = __webpack_public_path__ + "img/software_cosmolex.71b1680c.jpg";